// @flow
import React from 'react';
import numeral from 'numeral';
import styled from '@emotion/styled';
import { get } from 'lodash/fp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faArrowsAltV } from '@fortawesome/free-solid-svg-icons';

import { TableRow, TableCell } from './Table';
import PlayerBar from './PlayerBar';

type Props = {
  idStr?: string,
  alterPosition?: Object,
  positionId?: string,
  image?: string,
  initials?: string,
  exposureWarning?: boolean,
  name?: string,
  positionAbbr?: string,
  labels?: Array<Object>,
  salary?: number,
  warning?: boolean,
  // onLock?: (string, string) => void,
  onSelectSettingsTab?: (tab: string) => void,
  onRemove?: (string, string) => void,
  onSwitchSelectedPosition?: () => void
  // onUnlock?: (string, string) => void
};

const defaultProps = {
  warning: false,
  image: undefined,
  initials: undefined,
  exposureWarning: false,
  alterPosition: undefined,
  labels: [],
  idStr: undefined,
  name: undefined,
  positionId: undefined,
  positionAbbr: undefined,
  salary: undefined,
  // onLock: undefined,
  onRemove: undefined,
  onSelectSettingsTab: undefined,
  onSwitchSelectedPosition: undefined
  // onUnlock: undefined
};

const StyledButton = styled.button(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1
}));

const SwithPostionIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  marginRight: theme.spacing.tiny
}));

const SelectedEntityRow = ({
  name,
  image,
  warning,
  initials,
  alterPosition,
  exposureWarning,
  onSelectSettingsTab,
  onSwitchSelectedPosition,
  onRemove,
  idStr,
  labels,
  positionId,
  positionAbbr,
  salary
}: Props) => {
  const handleRemove = () => {
    if (onRemove) {
      onRemove(idStr, positionId);
    }
  };

  const handleSwitchSelectedPosition = () => {
    if (alterPosition && !alterPosition.filled) {
      onSwitchSelectedPosition(idStr, positionId, alterPosition.key);
    }
  };

  return (
    <TableRow className="is-mobile">
      <TableCell className="is-1">{positionAbbr}</TableCell>
      <TableCell className="is-6">
        {!!name && (
          <PlayerBar
            name={name}
            labels={labels}
            image={image}
            initials={initials || ''}
            warning={warning}
            exposureWarning={exposureWarning}
            onSelectSettingsTab={onSelectSettingsTab}
          />
        )}
      </TableCell>
      <TableCell className="is-2">{salary ? numeral(salary).format('$0,0.[00]') : ''}</TableCell>
      <TableCell className="is-3">
        {!!name && (
          <React.Fragment>
            <button type="button" onClick={handleRemove}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
            {alterPosition && (
              <StyledButton
                type="button"
                onClick={alterPosition.filled ? undefined : handleSwitchSelectedPosition}
                disabled={alterPosition.filled}
              >
                <SwithPostionIcon icon={faArrowsAltV} />
                <span>{get('abbr', alterPosition)}</span>
              </StyledButton>
            )}
          </React.Fragment>
        )}
      </TableCell>
    </TableRow>
  );
};

SelectedEntityRow.defaultProps = defaultProps;

export default SelectedEntityRow;
